export const useMainMenuStore = defineStore('mainMenu', {
  state: () => ({
    leakProfile: null as LeakProfile|null,
    drawerMode: 'auto' as 'auto' | 'collapsed' | 'expanded',
  }),
  persist: {
    storage: localStorage,
    pick: ['drawerMode'],
  },
});
